import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Treatments.css";
import logo from '../images/6_Ayur copy.webp'
import serviceImg from "../images/main_hair.webp";
import AyurvedaFooter from "../AyurvedaFooter/AyurvedaFooter";
import ScrollToTop from '../ScrollToTop'
import { MdCall } from "react-icons/md";
import { Link, NavLink, useLocation } from "react-router-dom";
import WhatsAppButton from "../WhatsAppButton";
import { FaLocationArrow } from "react-icons/fa6";
import ScrollTop from "../ScrollTop";
import { MdOutlineMail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { Helmet } from 'react-helmet-async';


export default function HairTreatment() {
  const location = useLocation();

  const isTreatmentActive =
    location.pathname.startsWith("/treatment") ||
    location.pathname.startsWith("/postnatal") ||
    location.pathname.startsWith("/rejuvenation") ||
    location.pathname.startsWith("/hair_treatment") ||
    location.pathname.startsWith("/lifestyle_yoga") ||
    location.pathname.startsWith("/soundarya_kalpa");
  return (
    <>
    <Helmet>
  <title>
    Ayurvedic Hair Treatment in Kerala | Ayurmoksha Ayurveda Clinic
  </title>

  <meta
    name="description"
    content="Restore healthy hair naturally with authentic Ayurvedic hair treatments at Ayurmoksha Ayurveda clinic in Kozhikode, Kerala. Our traditional therapies address hair fall, dandruff, premature greying, scalp disorders, and hair thinning using classical Ayurvedic oils, herbs, and personalized care."
  />

  <meta
    name="keywords"
    content="Ayurvedic Hair Treatment Kozhikode, Hair Fall Treatment Ayurveda Kerala, Ayurvedic Hair Therapy Kerala, Ayurmoksha Hair Treatment, Scalp Treatment Ayurveda, Natural Hair Care Ayurveda, Best Hair Treatment Ayurveda Kozhikode, Ayurvedic clinic Kerala"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/hair" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Ayurvedic Hair Treatment | Ayurmoksha Ayurveda clinic Kozhikode"
  />
  <meta
    property="og:description"
    content="Ayurmoksha Ayurveda clinic in Kozhikode offers traditional Ayurvedic hair treatments to reduce hair fall, improve scalp health, strengthen hair roots, and promote natural hair growth."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/hair"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda clinic"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Ayurvedic Hair Treatment at Ayurmoksha Ayurveda clinic in Kozhikode Kerala"
  />

  <meta name="author" content="Ayurmoksha Ayurveda clinic" />
</Helmet>

    <ScrollTop/>
    {/* main section */}
      <section className=" container-fluid about-main-section">
      {/* Overlay */}
      <div className="about-main-overlay"></div>

      {/* Navbar */}
       <nav className="navbar navbar-expand-lg navbar-dark about-navbar">
        <div className="container">

          {/* Logo */}
           <Link className="navbar-brand" to="#"><span><img src={logo} alt="logo" className="brand-logo bg_new"/><span  className=" logo_txt mt-5" ></span></span>
          </Link>

          {/* Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#aboutNavbar"
            aria-controls="aboutNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse justify-content-center" id="aboutNavbar">

             <ul className="navbar-nav align-items-lg-center gap-lg-3 text-center">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Home</b></NavLink>
              </li>

              <li className="nav-item">
              
                <NavLink  className="nav_Active" to="/ourstory" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Our Story</b></NavLink>
              </li>

             <li className="nav-item dropdown">
  <NavLink
    to="/treatment"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={() => ({
      color: isTreatmentActive ? "orange" : "white"
    })}
  >
    <b>Treatments</b>
  </NavLink>

  <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        All Treatments
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/postnatal"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Postnatal Care
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/rejuvenation"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Rejuvenation Therapy
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/hair_treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Hair Treatment
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/lifestyle_yoga"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Life Style Guidance & Yoga
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/soundarya_kalpa"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Soundarya Kalpa
      </NavLink>
    </li>
  </ul>
</li>

                <li className="nav-item">
                  <NavLink className="nav_Active" to="/contact" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>contact</b></NavLink>
              </li>
             
            </ul>
          </div>

        </div>
        <div className="d-none d-lg-flex align-items-center gap-3 ms-auto">
<span className="phone-inline">
  <MdCall /> <b>+91 7736 111 482</b>
</span>


  <a
    href="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20treatments"
    target="_blank"
    rel="noopener noreferrer"
    className="messenger-btn"
    style={{ backgroundColor: "#006400", textDecoration: "none" }}
  >
    WhatsApp
  </a>
</div>

      </nav>

      {/* Center Content */}
      <div className="about-main-content">
        <h1 className="head-font" style={{color:'#f7f0d3'}}> Hair Treatments</h1>
        <p>
          <span className="para-font">Home</span>
          <span className="mx-2">»</span>
          <span className="para-font"> Hair Treatments</span>
        </p>
      </div>
    </section>
    {/* =========== */}
    <section className="container-fluid service-detail-wrapper">
      <div className="container">
        <div className="row">

          {/* LEFT CONTENT */}
          <div className="col-lg-8 mb-5 mb-lg-0">
            <div className="service-image">
              <img src={serviceImg} alt="Abhyanga Therapy"/>
            </div>

            <h2 className="service-title head-font">Hair Treatment</h2>

            <p className="service-desc para-font justify-text">
             Experience the art of Ayurvedic hair care, where herbal oils, ancient therapies, and our specially prepared Ayurvedic medicines nourish your scalp and awaken the hair root. By balancing the doshas, strengthening follicles, and improving scalp health, this treatment promotes natural hair growth while helping prevent hair fall, thinning, and premature greying. It restores strength, shine, and vitality, leaving your hair healthy, glossy, resilient, and full of life.
            </p>

            <h5 className="service-subtitle head-font">Benefits of Hair Treatment</h5>

            <div className="row service-benefits">
              <div className="col-md-6">
                <ul className="para-font">
                  <li>✔ Reduces hair fall and strengthens follicles</li>
                  <li>✔ Prevents premature greying and thinning</li>
                  <li>✔ Promotes healthy hair growth and scalp vitality</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="para-font">
                  <li>✔ Restores natural shine, texture, and volume</li>
                  <li>✔ Nourishes and hydrates hair deeply</li>
                  <li>✔ Balances doshas for overall scalp and hair wellness</li>
                </ul>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="service-sidebar">

              <div className="sidebar-card">
                 <h5 className="head-font"  style={{color:'wheat'}}>Our Services</h5>
                <ul className="para-font">
                  <li><FaLocationArrow />&nbsp;&nbsp;Postnatal Care</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Rejuvenation Therapy</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Hair Treatments</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Life Style Guidance & Yoga</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Soundarya Kapla</li>
                </ul>
              </div>

              <div className="sidebar-card">
               

                <h5 className="head-font"  style={{color:'wheat'}}>Treatment Overview</h5>
                <ul>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Shirodhara</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Ksheeradhara</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Thakradhara</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Thalam</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Keshadhoomam</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Herbal scalp cleansing</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Herbal hair packs (Lepanam)</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Shiro Abhyangam</li>
                  <li className="para-font"><FaLocationArrow />&nbsp;&nbsp;Internal Medication </li>
                </ul>
              </div>

              <div className="sidebar-card">
                 <h5 className="head-font" style={{color:'wheat'}}>Our Contact</h5>
                     <ul className="para-font">
                    <li><FaPhone/> +91 7736 111 482</li>
                   <li><MdOutlineMail/> ayurmokshacalicut@gmail.com</li>
                  <li><FaLocationDot/>&nbsp;Ruby Road, Karuvanthuruthy, Feroke, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Kozhikode,Kerala 673631</li>
                 </ul>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
    <AyurvedaFooter/>
   <ScrollToTop/>
    <WhatsAppButton/>
    </>
  );
}
